import { Alert, AlertTitle, Button, Box } from '@mui/material';
import { usePage, router } from '@inertiajs/react';
import EmailIcon from '@mui/icons-material/Email';

export default function EmailVerificationBanner() {
    const { auth } = usePage().props;
    
    // Only show if user is logged in and email is not verified
    if (!auth?.user || auth.user.email_verified_at) {
        return null;
    }
    
    return (
        <Alert 
            severity="warning" 
            icon={<EmailIcon />}
            action={
                <Button 
                    color="inherit" 
                    size="small"
                    onClick={() => router.get(route('verification.notice'))}
                >
                    Verify Now
                </Button>
            }
            sx={{ 
                borderRadius: 0,
                position: 'sticky',
                top: 0,
                zIndex: 1200,
            }}
        >
            <AlertTitle>Email Verification Required</AlertTitle>
            Please verify your email address to access all features. Some actions may be restricted until verification is complete.
        </Alert>
    );
}